import { logger } from '@mail-core/logger';
import { Icon24ShareExternalOutline } from '@vkontakte/icons';
import { Spacing, Text, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import bone from 'img/nestleLanding/bone.png';
import lapka from 'img/nestleLanding/lapka.png';
import { ReactComponent as CloudLogoHeader } from 'img/nestleLanding/Logo_Header.svg';
import { ReactComponent as CloudLogoHeaderMobile } from 'img/nestleLanding/Logo_Header_Mobile.svg';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { sendNestleLandingSnitch } from 'reactApp/sections/Nestle/NestleLanding.analytics';
import { Button } from 'reactApp/ui/Button/Button';

import styles from './HeaderNestle.css';

const NESTLE_LINK_COPY = 'NESTLE_LINK_COPY';
const NESTLE_LINK_ERROR = 'NESTLE_LINK_ERROR';

export const HeaderNestle = () => {
    const dispatch = useDispatch();
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);

    const handleClick = async () => {
        const url = new URL(window.location.href);

        url.searchParams.set('utm_source', 'sharing');

        try {
            await navigator.clipboard.writeText(url.toString());
            dispatch(
                showSnackbarAction({
                    text: 'Ссылка скопирована',
                    type: SnackbarTypes.success,
                    id: NESTLE_LINK_COPY,
                    closable: true,
                })
            );
            sendNestleLandingSnitch('share');
        } catch (error) {
            logger.error(error);
            dispatch(
                showSnackbarAction({
                    text: 'Не удалось скопировать ссылку',
                    type: SnackbarTypes.failure,
                    id: NESTLE_LINK_ERROR,
                    closable: true,
                })
            );
        }
    };

    return (
        <>
            <div
                className={classNames(styles.share, {
                    [styles.sharePhone]: isMobile,
                })}
            >
                {!isMobile ? (
                    <a href="http://cloud.mail.ru/?utm_source=cloud&utm_medium=landing&utm_campaign=header">
                        <CloudLogoHeader width="141" height="32" />
                    </a>
                ) : (
                    <div className={styles.phoneLogoContainer}>
                        <a href="http://cloud.mail.ru/?utm_source=cloud&utm_medium=landing&utm_campaign=header">
                            <CloudLogoHeaderMobile width="147" height="33" />
                        </a>
                    </div>
                )}
                <Button
                    className={classNames(styles.btnContainer, {
                        [styles.btnContainerPhone]: isMobile,
                    })}
                    onClick={handleClick}
                >
                    {isMobile ? <Icon24ShareExternalOutline /> : 'Поделиться'}
                </Button>
            </div>
            <div
                className={classNames(styles.mainText, {
                    [styles.mainTextMobile]: isMobile,
                })}
            >
                <Title
                    className={classNames(styles.title, {
                        [styles.titlePhone]: isMobile,
                    })}
                >
                    <span className={styles.line}>перекличка</span>
                    {!isMobile ? (
                        <>
                            <span className={styles.imgBoneWrapper}>
                                <img src={bone} alt="кость" className={styles.img} />
                            </span>
                            <span>по</span>
                            <span className={styles.imgPawWrapper}>
                                <img src={lapka} alt="лапка" className={styles.img} />
                            </span>
                            <span>кличкам</span>
                        </>
                    ) : (
                        <>
                            <span className={styles.line}>
                                <span className={styles.line}>по</span>
                                <span
                                    className={classNames(styles.imgBoneWrapper, {
                                        [styles.imgBoneWrapperPhone]: isMobile,
                                    })}
                                >
                                    <img src={bone} alt="кость" className={styles.img} />
                                </span>
                                <span>кличкам</span>
                                <span
                                    className={classNames(styles.imgPawWrapper, {
                                        [styles.imgPawWrapperPhone]: isMobile,
                                    })}
                                >
                                    <img src={lapka} alt="лапка" className={styles.img} />
                                </span>
                            </span>
                        </>
                    )}
                </Title>
                <Spacing size={12} />
                <Text
                    className={classNames(styles.text, {
                        [styles.textPhone]: isMobile,
                    })}
                >
                    Заполните карточку питомца, чтобы узнать популярные клички и&nbsp;выиграть сертификаты на покупки&nbsp;&mdash; корм,
                    вкусняшки, шлейки и&nbsp;что&#8209;то для себя
                </Text>
            </div>
        </>
    );
};
